const prefix = "PAGE/";

// Load
export const SET_PLAYING = `${prefix}SET_PLAYING`;
export const SET_WIN_WIDTH = `${prefix}SET_WIN_WIDTH`;

export default () => {};
